var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',{ref:"pond",attrs:{"allow-multiple":false,"server":_vm.myServer,"label-idle":_vm.$t('hint'),"max-files":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }